export function GetAppsNotificationTypes() {
  return [
    {
      key: 0,
      description: "All"
    },
    {
      key: 1,
      description: "SpecificUser"
    },
    {
      key: 2,
      description: "Criteria"
    },
    {
      key: 3,
      description: "SpecificIdrUser"
    },
    {
      key: 4,
      description: "SpecificSgdUser"
    }
  ];
}

export function GetAppNotificationTypeDescription(value) {
  let appsNotificationType = GetAppsNotificationTypes().find(
    item => item.key === value
  );
  return appsNotificationType ? appsNotificationType.description : "Unknown";
}

export function GetAppNotificationTypeKey(value) {
  let appsNotificationType = GetAppsNotificationTypes().find(
    item => item.description === value
  );
  return appsNotificationType ? appsNotificationType.key : null;
}
